import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import PasswordChangePage from 'Route/PasswordChangePage/PasswordChangePage.component';
import { STATUS_PASSWORD_UPDATED } from 'SourceRoute/PasswordChangePage/PasswordChangePage.config';
import {
    mapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    PasswordChangePageContainer as SourcePasswordChangePageContainer,
} from 'SourceRoute/PasswordChangePage/PasswordChangePage.container';
import { getQueryParam } from 'Util/Url';

export { mapDispatchToProps };

/** @namespace Advox/Route/PasswordChangePage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    passwordMinLength: state.ConfigReducer.minimum_password_length,
    passwordClassesLength: state.ConfigReducer.required_character_classes_number,
});

/** @namespace Advox/Route/PasswordChangePage/Container */
export class PasswordChangePageContainer extends SourcePasswordChangePageContainer {
    static propTypes = {
        ...SourcePasswordChangePageContainer.propTypes,
        passwordResetMessage: PropTypes.string,
        passwordMinLength: PropTypes.string,
        passwordClassesLength: PropTypes.string,
    };

    containerProps() {
        const { isLoading } = this.state;
        const { passwordMinLength, passwordClassesLength } = this.props;

        return { isLoading, passwordMinLength, passwordClassesLength };
    };

    render() {
        const { passwordResetStatus } = this.state;
        const token = getQueryParam('token', location);

        if (!token || passwordResetStatus === STATUS_PASSWORD_UPDATED) {
            return <Redirect to="/" />;
        }

        return <PasswordChangePage {...this.containerProps()} {...this.containerFunctions} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordChangePageContainer);
